"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_LoaderContainer = exports.Occ_Loader = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var occSpinner = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    to {\n        transform: rotate(360deg);\n    }\n"])));
var Occ_Loader = (0, _styledComponents["default"])('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    animation: ", " 1s linear infinite;\n    border-radius: var(--border-radius-full);\n    width: ", ";\n    height: ", ";\n    border-right: ", ";\n    border-top: ", ";\n"])), occSpinner, function (props) {
  if (props.size === 'small') {
    return '30px';
  } else if (props.size === 'medium') {
    return '60px';
  } else if (props.size === 'large') {
    return '90px';
  }
}, function (props) {
  if (props.size === 'small') {
    return '30px';
  } else if (props.size === 'medium') {
    return '60px';
  } else if (props.size === 'large') {
    return '90px';
  }
}, function (props) {
  if (props.size === 'small') {
    return '2px solid transparent';
  } else if (props.size === 'medium') {
    return '4px solid transparent';
  } else if (props.size === 'large') {
    return '6px solid transparent';
  }
}, function (props) {
  if (props.size === 'small' && props.color === 'primary') {
    return '2px solid var(--color-primary-highlight)';
  } else if (props.size === 'small' && props.color === 'secondary') {
    return '2px solid var(--color-secondary-highlight)';
  } else if (props.size === 'medium' && props.color === 'primary') {
    return '4px solid var(--color-primary-highlight)';
  } else if (props.size === 'medium' && props.color === 'secondary') {
    return '4px solid var(--color-secondary-highlight)';
  } else if (props.size === 'large' && props.color === 'primary') {
    return '6px solid var(--color-primary-highlight)';
  } else if (props.size === 'large' && props.color === 'secondary') {
    return '6px solid var(--color-secondary-highlight)';
  }
});
exports.Occ_Loader = Occ_Loader;
var Occ_LoaderContainer = (0, _styledComponents["default"])('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--color-base-white);\n"])));
exports.Occ_LoaderContainer = Occ_LoaderContainer;